import { jsxs as i, jsx as o, Fragment as S } from "react/jsx-runtime";
import { PortableText as _ } from "@portabletext/react";
import "js-cookie";
import { useState as h, useCallback as x } from "react";
import { useMediaQuery as N } from "../../hooks/useMediaQuery.js";
import n from "clsx";
import { FlavorBubble as P } from "../FlavorBubble/FlavorBubble.js";
import '../../theme.css';import '../../_assets/FlavorsSelector.BXsO__hF.css';/* empty css                                          */
var w = "FlavorsSelector_spanFragment__1m7gpn80", j = "FlavorsSelector_flavorsContainer__1m7gpn81", A = "FlavorsSelector_isRow__1m7gpn82", L = "FlavorsSelector_flavorLabel__1m7gpn83", R = "FlavorsSelector_flavorPalette__1m7gpn84";
const E = ({
  className: s,
  useRow: f = !1,
  interactionDisabled: e = !1,
  showFlavorNames: v = !1,
  flavors: l,
  translations: { customLabel: m, flavorsCounter: c },
  onFlavorClick: t,
  styleOverrides: a
}) => {
  const g = N("s"), [p, u] = h(l[0]), F = x(
    (r) => {
      u(r), t == null || t(r);
    },
    [t]
  ), b = () => m ? /* @__PURE__ */ o(_, { value: m }) : !e && g ? p.label || "Unknown Flavor" : l.length && c ? /* @__PURE__ */ i(S, { children: [
    l.length,
    " ",
    /* @__PURE__ */ o("span", { className: w, children: /* @__PURE__ */ o(_, { value: c }) })
  ] }) : null;
  return /* @__PURE__ */ i("div", { className: n(j, f && A, s), children: [
    /* @__PURE__ */ o("div", { className: n(L, a == null ? void 0 : a.label), children: b() }),
    /* @__PURE__ */ o("div", { className: n(R, a == null ? void 0 : a.flavorPalette), children: l.map((r) => /* @__PURE__ */ o(
      P,
      {
        interactionDisabled: e,
        flavor: r,
        renderFlavorName: v,
        isActive: p.id === r.id,
        styleOverrides: a,
        onFlavorClick: F
      },
      r.id
    )) })
  ] });
};
export {
  E as FlavorsSelector
};
